import { useI18nP, type PlatformKey } from '../../i18n';
import type { Cause } from '../../lib/slarca';

/** Nome da causa no idioma da pessoa: o nome dado pela empresa ou a tradução da chave padrão. */
export function useCauseLabel() {
  const { t, has } = useI18nP();
  return (key: string | null | undefined, c?: Pick<Cause, 'name' | 'label'> | null) => {
    if (!key) return t('rca.none');
    if (c?.name) return c.name;
    return has(`rca.cause.${key}`) ? t(`rca.cause.${key}` as PlatformKey) : (c?.label ?? key);
  };
}
